import axiosOverlay from '../../js/axiosOverlay'

const state = {
    evenements: null,
    selectedEvenement: null,
    iCanWrite: [],
    iCantRead: []
};

const getters = {
    evenements: state => state.evenements,
    selectedEvenement: state => state.selectedEvenement,
    iCanWrite: state => state.iCanWrite,
    iCantRead: state => state.iCantRead,
    getEvenementById: (state) => (evenementID) => {
        return JSON.parse(state.evenements)?.find(evenement => evenement.id === evenementID) ?? null
    },
    getMyEvenement: (state, getters, rootState, rootGetters) => {
        let myEvenement = []
        let allEvenement = JSON.parse(state.evenements)
        if (allEvenement) {
            allEvenement.forEach(function(evenement) {
                let flag = true
                if (evenement.roleFiltres != null) {
                    rootGetters['user/getRoles'].forEach(function (role) {
                        if (evenement.roleFiltres.includes(role)) {
                            flag = false
                        }
                    });
                }
                if (flag){
                    myEvenement.push(evenement)
                }
            });
        }
        return myEvenement
    }
};

const mutations = {
    SET_EVENEMENTS(state, evenements) {
        state.evenements = evenements;
    },
    SET_SELECTED_EVENEMENT(state, evenement) {
        state.selectedEvenement = evenement;
    },
    SET_I_CAN_WRITE(state, list) {
        state.iCanWrite = list;
    },
    SET_I_CANT_READ(state, list) {
        state.iCantRead = list;
    }
};

const actions = {
    async loadEvenementsFromAPI({ commit, state, rootGetters }) {
        if (state.evenements == null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/suivisollicitation/evenements",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_EVENEMENTS', result);

                let iCanWrite = [];
                let iCantRead = [];
                let allEvenement = JSON.parse(result);
                
                allEvenement.forEach(function (evenement) {
                    // Remplissage de ce que je peux écrire
                    let flagWrite = true;
                    if (evenement.roleFiltresWrite != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (evenement.roleFiltresWrite.includes(role)){
                                flagWrite = false;
                            }
                        });
                    }
                    if (flagWrite) {
                        iCanWrite.push(evenement);
                    }

                    // Remplissage de ce que je peux lire
                    let flagRead = true;
                    if (evenement.roleFiltresRead != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (evenement.roleFiltresRead.includes(role)){
                                flagRead = false;
                            }
                        });
                    }
                    if (!flagRead) {
                        iCantRead.push(evenement);
                    }
                });
                
                commit('SET_I_CAN_WRITE', iCanWrite);
                commit('SET_I_CANT_READ', iCantRead);
                
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    setSelectedEvenement({ commit }, evenementID) {
        commit('SET_SELECTED_EVENEMENT', evenementID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
